/**
 * frontend/src/pages/NotAuthorizedPage.jsx
 * Shown when a user navigates to a page their role cannot access.
 * Replaces the current "blank screen" experience.
 */
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function NotAuthorizedPage() {
  const navigate  = useNavigate();
  const { user }  = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center p-6"
      style={{ background:'var(--bg)' }}>
      <div className="text-center max-w-md">
        <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6"
          style={{ background:'rgba(239,68,68,.1)' }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
            stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
        </div>

        <h1 className="text-2xl font-bold mb-2" style={{ color:'var(--text)' }}>
          Access Restricted
        </h1>
        <p className="text-sm mb-2" style={{ color:'var(--text-secondary)' }}>
          Your role (<strong>{user?.role}</strong>) does not have permission to access this page.
        </p>
        <p className="text-sm mb-8" style={{ color:'var(--text-secondary)' }}>
          If you believe this is a mistake, ask an Admin to update your access in the Admin Panel
          under Roles &amp; Permissions.
        </p>

        <div className="flex justify-center gap-3">
          <button onClick={() => navigate(-1)} className="btn-secondary text-sm">
            Go Back
          </button>
          <button onClick={() => navigate('/')} className="btn-primary text-sm">
            Return to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
